import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/local-storage/local-storage.service';
import { inject } from '@angular/core';

export const ngoAdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);

  if (localStorageService.getIsNgoAdmin()) {
    return true;
  } else {
    return false;
  }
};